var _path, _path2, _rect, _rect2, _rect3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPgn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 443,
    height: 443,
    viewBox: "0 0 443 443",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M442.649 221.325C442.649 343.559 343.559 442.649 221.325 442.649C99.0904 442.649 0 343.559 0 221.325C0 99.0904 99.0904 0 221.325 0C343.559 0 442.649 99.0904 442.649 221.325Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M221.325 426.649C334.722 426.649 426.649 334.722 426.649 221.325C426.649 107.927 334.722 16 221.325 16C107.927 16 16 107.927 16 221.325C16 334.722 107.927 426.649 221.325 426.649ZM221.325 442.649C343.559 442.649 442.649 343.559 442.649 221.325C442.649 99.0904 343.559 0 221.325 0C99.0904 0 0 99.0904 0 221.325C0 343.559 99.0904 442.649 221.325 442.649Z",
    fill: "black"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 120.847,
    y: 121.312,
    width: 129.35,
    height: 129.35,
    fill: "black",
    stroke: "black",
    strokeWidth: 12
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 186.451,
    y: 185.987,
    width: 141.35,
    height: 141.35,
    fill: "black"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 192.226,
    y: 191.987,
    width: 57.9695,
    height: 57.9695,
    fill: "white",
    stroke: "black",
    strokeWidth: 12
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPgn);
export default __webpack_public_path__ + "static/media/pgn.5bdd6b859cc203143cef2136861c4541.svg";
export { ForwardRef as ReactComponent };